module.exports = __webpack_public_path__ + "static/media/visit-logo.a00e3dff.svg";